<template>
  <div style="height: 51px;">
    <div class="header_drawer">
        <div class="header_nav">
            <div class="header_container">
                <!-- logo -->
                <div class="avatar">
                    <router-link to="/">
                        <img src="../../assets/header/资源 167.png" @click="changeActiveState">
                    </router-link>
                </div>
                <!-- <button @click="showDrawer">展开</button> -->
                <div class="nav_list">
                    <el-menu
                        :default-active="navIndex"
                        mode="horizontal"
                        @select="handleSelect"
                        :router="true"
                        ref="menu"
                        >
                        <el-menu-item index="/index">
                            <div :class="['item_inner', navIndex==='/index'?'item_inner_active':'']"  @mouseenter="closeTwoDrawer(false)">首页</div>
                        </el-menu-item>
                        <el-menu-item index="/pongo">
                            <div :class="['item_inner', navIndex==='/pongo'?'item_inner_active':'']" @mouseenter="showDrawer2(true)" @mouseleave="isShowDrawer2">数字孪生平台</div>
                        </el-menu-item>
                        <el-menu-item index="/models"><div :class="['item_inner', navIndex==='/models' ? 'item_inner_active':'']" @mouseenter="closeTwoDrawer(false)">模型库</div></el-menu-item>
                        <el-menu-item index="/digital_twin">
                            <div :class="['item_inner', navIndex==='/digital_twin' ? 'item_inner_active':'']" @mouseenter="showDrawer(true)" @mouseleave="isShowDrawer3">定制服务</div>
                        </el-menu-item>
                        <!-- <el-menu-item index="/help"><div :class="['item_inner', navIndex==='/help' ? 'item_inner_active':'']" @mouseenter="showDrawer(false)">帮助中心</div></el-menu-item> -->
                        <el-menu-item index="/about"><div :class="['item_inner', navIndex==='/about' ? 'item_inner_active':'']" @mouseenter="showDrawer(false)">关于矢量</div></el-menu-item>
                    </el-menu>
                    <!-- 右侧头像 -->
                    <div class="user_avatar" @mouseenter="showLogout" @mouseleave="hiddenLogout">
                        <!-- <span style="color: azure;">{{ state }}</span> -->
                        <div v-show="state">
                            <div class="avatar_container">
                                <img :src="userInformation.avatar ? userInformation.avatar : require('../../assets/image/资源 38.png')" style="width: 2.25rem; height: 2.25rem; border-radius: 90%;">
                                <img src="../../assets/header/5.头像下拉.png">
                            </div>
                        </div>
                        <div v-show="!state">
                            <el-button @click="dialogFormVisible = true">登录/注册</el-button>
                        </div>
                    </div>
                </div>
                
                <!-- 下拉登出 -->
                <div class="logout" v-show="state&&isShowLogout" @mouseenter="showLogout" @mouseleave="hiddenLogout">
                <!-- <div class="logout" @mouseenter="showLogout" @mouseleave="hiddenLogout"> -->
                    <div class="logout_avatar">
                        <img :src="userInformation.avatar!==null ? userInformation.avatar : require('../../assets/image/资源 38.png')" style="width: 4rem; height: 4rem; border-radius: 90%;">
                        <div class="user_name">{{ userInformation.account }}</div>
                    </div>
                    <div class="logout_line">
                        <img src="../../assets/image/8.下拉矩形内横线.png">
                    </div>
                    <div class="user_center">
                        <el-button @click="goUser">个人中心</el-button>
                        <el-button @click="userLogout">退出登录</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isDrawer2" class="drawer" @mouseenter="changeIsDrawer2(true)" @mouseleave="changeIsDrawer2(false)">
            <div class="drawer_container">
                <ul v-for="(item, index) in serverNav" :key="index" class="container">
                    <li class="drawer_title" @click="navTwoClickHandle()">
                        <router-link :to="item.toTitle">
                            <span class="inner_tittle">{{ item.title }}</span>
                        </router-link>
                    </li>
                    <li class="drawer_inner" v-for="(j, jIndex) in item.content" :key="jIndex" @click="navTwoClickHandle()">
                        <router-link :to="item.to[jIndex]">
                            <span class="drawer_inner_span">{{ j }}</span>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="isDrawer3" class="drawer drawer2" @mouseenter="changeIsDrawer3(true)" @mouseleave="changeIsDrawer3(false)">
            <div class="drawer_container drawer_container_bgc">
                <div class="pongo_intro">
                    <p>{{ ponGoIntroduce[0] }}</p>
                    <p>{{ ponGoIntroduce[1] }}</p>
                </div>
                <div class="pongo_nav_list">
                    <div class="list_container">
                        <div v-for="(item, index) in ponGoNav" :key="index" class="item" @click="goPongo(item.to)">
                            {{ item.title }}3
                        </div>
                    </div>
                </div>
                <div class="pongo_logo">
                    <img src="../../assets/image/logo.png" style="width: 6rem">
                </div>
            </div>
        </div>
    </div>
     <!-- 二级菜单 -->
    <el-dialog center :visible.sync="dialogFormVisible" :lock-scroll="false" @close="closeDialog">
        <div class="dialog_container">
            <div class="dialog_left">
                <img src="../../assets/image/logo.png" style="width: 30%;">
                <p class="name">PONGO（胖狗）产线三维仿真软件</p>
            </div>
            <div class="dialog_right">
                <!-- 登录 -->
                <div class="right_container" v-if="loginOrRegister==='login'">
                    <!-- 账号登录 -->
                    <div class="login_format" v-if="wxLogin==='account'">
                        <p class="title">用户登录</p>
                        <el-form :model="ruleForm" status-icon :rules="rules" ref="loginRef" label-width="100px" class="demo-ruleForm">
                            <el-form-item prop="accountLogin">
                                <el-input v-model="ruleForm.accountLogin" auto-complete="off" placeholder="账号" @focus="focusHandle(0)">
                                    <i slot="prefix">
                                        <img src="../../assets/image/网站3-02.jpg" style="width: 20px; height: 20px;" v-if="!focusArrayLogin[0]">
                                        <img src="../../assets/image/网站3-09.jpg" style="width: 20px; height: 20px;" v-else>
                                    </i>
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="passLogin">
                                <el-input type="password" v-model="ruleForm.passLogin" auto-complete="off" placeholder="密码" @focus="focusHandle(1)">
                                    <i slot="prefix">
                                        <img src="../../assets/image/网站3-03.jpg" style="width: 25px; height: 25px; margin-top: 5px;" v-if="!focusArrayLogin[1]">
                                        <img src="../../assets/image/网站3-10.jpg" style="width: 25px; height: 25px; margin-top: 5px;" v-else>
                                    </i>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <div class="forget" >
                                    <span @click="changePassword">忘记密码?</span>
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <div class="button">
                                    <el-button @click="userToLogin" class="login">登&nbsp;&nbsp;录</el-button>
                                    <!-- <el-button @click="toRegister" class="register">免费注册</el-button> -->
                                </div>
                            </el-form-item>
                        </el-form>
                        <div class="other">其他登录方式</div>
                        <div class="bottom">
                            <div class="wx" @click="changeWXLogin('wx')">
                                <img src="../../assets/image/网站3-17.png" style="width: 30px; height: 30px;">
                                <span>微信登录</span>
                            </div>
                            <div class="dx" @click="changeWXLogin('dx')">
                                <img src="../../assets/image/网站3-18.png" style="width: 30px; height: 30px;">
                                <span>短信登录</span>
                            </div>
                        </div>
                    </div>
                    <!-- 微信登录 -->
                    <div class="login_format" v-else-if="wxLogin==='wx'">
                        <!-- <p class="title">微信登录</p> -->
                        <!-- <el-button @click="testCode">微信登录</el-button> -->
                        <div class="weixin">
                            <!-- <div id="wx_login_container" style="height: 300px;"></div> -->
                            <wxlogin appid="wxd6125d826622af59" scope="snsapi_login" :theme="'black'" 
                            :redirect_uri='encodeURIComponent("http://www.pongo.net.cn/")' :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlewogICAgICAgICAgICAgICAgICAgIGRpc3BsYXk6IG5vbmU7CiAgICAgICAgICAgICAgICB9'"></wxlogin>
                        </div>
                        <div class="other">其他登录方式</div>
                        <div class="bottom">
                            <div class="wx" @click="changeWXLogin('account')">
                                <img src="../../assets/image/网站3-16.png" style="width: 30px; height: 30px;">
                                <span>密码登录</span>
                            </div>
                            <div class="dx" @click="changeWXLogin('dx')">
                                <img src="../../assets/image/网站3-18.png" style="width: 30px; height: 30px;">
                                <span>短信登录</span>
                            </div>
                        </div>
                    </div>
                    <!-- 短信登录 -->
                    <div class="login_format" v-else-if="wxLogin==='dx'">
                        <p class="title">短信登录</p>
                        <div class="duanxin">
                            <el-form :model="ruleFormMessage" status-icon :rules="messageRules" ref="ruleFormMessage" label-width="100px" class="demo-ruleForm">
                                <el-form-item prop="phone">
                                    <el-input v-model="ruleFormMessage.phone" placeholder="手机号" @focus="codeFocusHandle(0)">
                                        <i slot="prefix">
                                            <img src="../../assets/image/网站3-02.jpg" style="width: 20px; height: 20px;" v-if="!focusArrayCode[0]">
                                            <img src="../../assets/image/网站3-09.jpg" style="width: 20px; height: 20px;" v-else>
                                        </i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="code">
                                    <el-input v-model="ruleFormMessage.code" auto-complete="off" placeholder="验证码" @focus="codeFocusHandle(1)">
                                        <i slot="prefix">
                                            <img src="../../assets/image/网站3-03.jpg" style="width: 25px; height: 25px; margin-top: 5px;" v-if="!focusArrayCode[1]">
                                            <img src="../../assets/image/网站3-10.jpg" style="width: 25px; height: 25px; margin-top: 5px;" v-else>
                                        </i>
                                        <i slot="suffix">
                                            <el-button @click="getCode()" class="codeBtn" :disabled="isSending || countdown > 0">
                                                {{ isSending ? '发送中...' : countdown > 0 ? `${countdown}秒后重试` : "获取验证码" }}
                                            </el-button>
                                        </i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item>
                                    <div class="button">
                                        <el-button @click="MessageToLogin" class="login">登&nbsp;&nbsp;录</el-button>
                                    </div>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="other">其他登录方式</div>
                        <div class="bottom">
                            <div class="wx" @click="changeWXLogin('account')">
                                <img src="../../assets/image/网站3-16.png" style="width: 30px; height: 30px;">
                                <span>密码登录</span>
                            </div>
                            <div class="dx" @click="changeWXLogin('wx')">
                                <img src="../../assets/image/网站3-17.png" style="width: 30px; height: 30px;">
                                <span>微信登录</span>
                            </div>
                        </div>
                    </div>
                    <!-- 注册 -->
                    <div class="login_format" v-else-if="wxLogin==='zc'">
                        <p class="title">注册</p>
                        <div class="zhuce">
                            <el-form :model="ruleFormRegister" status-icon :rules="registerRules" ref="registerRef" label-width="100px" class="demo-ruleForm">
                                <el-form-item prop="accountRegister">
                                    <el-input v-model="ruleFormRegister.accountRegister" auto-complete="off" placeholder="账号" @focus="registerFocusHandle(0)">
                                        <i slot="prefix">
                                            <img src="../../assets/image/网站3-02.jpg" style="width: 20px; height: 20px;" v-if="!focusArrayRegister[0]">
                                            <img src="../../assets/image/网站3-09.jpg" style="width: 20px; height: 20px;" v-else>
                                        </i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="passwordRegister">
                                    <el-input type="password" v-model="ruleFormRegister.passwordRegister" auto-complete="off" placeholder="密码" @focus="registerFocusHandle(1)">
                                        <i slot="prefix">
                                            <img src="../../assets/image/网站3-03.jpg" style="width: 25px; height: 25px; margin-top: 5px;" v-if="!focusArrayRegister[1]">
                                            <img src="../../assets/image/网站3-10.jpg" style="width: 25px; height: 25px; margin-top: 5px;" v-else>
                                        </i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="rePassword">
                                    <el-input type="password" v-model="ruleFormRegister.rePassword" auto-complete="off" placeholder="再次输入密码" @focus="registerFocusHandle(2)">
                                        <i slot="prefix">
                                            <img src="../../assets/image/网站3-03.jpg" style="width: 25px; height: 25px; margin-top: 5px;" v-if="!focusArrayRegister[2]">
                                            <img src="../../assets/image/网站3-10.jpg" style="width: 25px; height: 25px; margin-top: 5px;" v-else>
                                        </i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="company">
                                    <el-input v-model="ruleFormRegister.company" auto-complete="off" placeholder="企业名称" @focus="registerFocusHandle(3)">
                                        <i slot="prefix">
                                            <img src="../../assets/image/网站3-08.jpg" style="width: 25px; height: 25px; margin-top: 5px;" v-if="!focusArrayRegister[3]">
                                            <img src="../../assets/image/网站3-15.jpg" style="width: 25px; height: 25px; margin-top: 5px;" v-else>
                                        </i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="tags">
                                    <el-input v-model="ruleFormRegister.tags" auto-complete="off" placeholder="业务类型" @focus="registerFocusHandle(5)">
                                        <i slot="prefix">
                                            <img src="../../assets/image/网站3-06.jpg" style="width: 25px; height: 25px; margin-top: 5px;" v-if="!focusArrayRegister[5]">
                                            <img src="../../assets/image/网站3-13.jpg" style="width: 25px; height: 25px; margin-top: 5px;" v-else>
                                        </i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="name">
                                    <el-input v-model="ruleFormRegister.name" placeholder="联系人姓名" @focus="registerFocusHandle(6)">
                                        <i slot="prefix">
                                            <img src="../../assets/image/网站3-05.jpg" style="width: 25px; height: 25px; margin-top: 5px;" v-if="!focusArrayRegister[6]">
                                            <img src="../../assets/image/网站3-12.jpg" style="width: 25px; height: 25px; margin-top: 5px;" v-else>
                                        </i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="phone">
                                    <el-input v-model="ruleFormRegister.phone" auto-complete="off" placeholder="联系电话" @focus="registerFocusHandle(7)">
                                        <i slot="prefix">
                                            <img src="../../assets/image/网站3-04.jpg" style="width: 25px; height: 25px; margin-top: 5px;" v-if="!focusArrayRegister[7]">
                                            <img src="../../assets/image/网站3-11.jpg" style="width: 25px; height: 25px; margin-top: 5px;" v-else>
                                        </i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item>
                                    <div class="button">
                                        <el-button @click="userToRegister" class="login">注&nbsp;&nbsp;册</el-button>
                                        <el-button @click="toLogin" class="register">返回登录</el-button>
                                    </div>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
  </div>
</template>

<!-- <script type="text/javascript" src="https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"></script> -->
<script>
import { userLogin, userExit, userRegister, getVerifyCode, verifyCodeLogin, getUserInfo } from '../../util/index'
import { serverNav, ponGoNav, ponGoIntroduce } from '../../util/constant'
import router from '../../router'
// import DiaLogin from '../../components/diaLogin/index.vue'
// import DiaRegister from '../../components/diaRegister/index.vue'
import wxlogin from 'vue-wxlogin'
import { md5 } from 'js-md5'
export default {
    data() {
        // 登录
        // 账号
        var checkLoginAccount = (rule, value, callback) => {
            console.log('点了账号');
            if (value === '') {
                return callback(new Error('登录账号不能为空'));
            }else {
                callback();
            }
        }
        // 密码
        var validateLoginPass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入登录密码'));
            } else {
                callback();
            }
        };
        // 注册
        // 账号
        var checkAccount = (rule, value, callback) => {
            console.log('出发了注册填姓名');
            if (!value) {
                return callback(new Error('注册账号不能为空'));
            }
        }
        // 密码
        var validatePass = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入注册密码'));
            } 
            setTimeout(() => {
                var myReg=/^(?=.*[a-z])(?=.*\d)[^]{8,16}$/;
                if (!myReg.test(value) ) {
                    callback(new Error('密码必须包含数字,字母,且不少于8位'));
                } else {
                    callback();
                }
            }, 1000);
        };
        // 手机号
        var checkNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机号不能为空'));
            }
            setTimeout(() => {
                // console.log(value);
                var myReg=/^[1][3,4,5,7,8][0-9]{9}$/;
                if (!myReg.test(value) ) {
                    callback(new Error('请输入正确的手机号码'));
                } else {
                    callback();
                }
            }, 1000);
        };
        var checkCode = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('验证码不能为空'));
            } else {
                callback();
            }
        };
        // 再次输入密码
        var validateRePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleFormRegister.passwordRegister) {
                console.log('我输入的密码是：',this.ruleFormRegister.passwordRegister)
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        }
        var validateCompany = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入公司名称'));
            } else {
                callback();
            }
        };
        var validateTest = (rule, value, callback) => {
            console.log('点了测试');
            if (value === '') {
                callback(new Error('请输入测试名字'));
            } else {
                callback();
            }
        }
        var validateAddr = (rule, value, callback) => {
            console.log('点了地址');
            if (value === '') {
                callback(new Error('请输入公司地址'));
            } else {
                callback();
            }
        }
        var validateName = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入联系人姓名'));
            } else {
                callback();
            }
        }
        // 注册
        // 账号
        var validateRegisterAccount = (rule, value, callback) => {
            console.log('出发了注册填姓名');
            if (!value) {
                return callback(new Error('注册账号不能为空'));
            } else {
                callback();
            }
        }
        // 密码
        var validateRegisterPass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入注册密码'));
            } else {
                callback();
            }
        }
        return {
            serverNav, // 下拉框
            ponGoNav, // 导航栏
            ponGoIntroduce, // 介绍
            state: false,  // 用户是否登录
            wxLogin: 'account',  // 微信登录
            isShowLogout: false,  // 是否展示登出界面
            selectNumber: false,  // 是否展示数字孪生平台下拉框
            selectService: false,   // 是否展示服务下拉框
            loginOrRegister:'login', // 当前是登录还是注册弹出框
            dialogFormVisible: false,  // 弹出是否可见
            isSending: false,  // 是否正在发送验证码
            countdown: 0, // 倒计时
            isDrawer2: false,  // 从抽屉中移入移出
            isDrawer3: false,  // PONGO的下拉菜单
            userInformation: {},  // 用户信息
            navIndex:'', // 导航数据
            navArray:['/pongo', '/models', '/digital_twin', '/help', '/about' ], // 导航数据
            ruleForm: {  // 登录的表单
                accountLogin: '',
                passLogin: '',
            },
            ruleFormRegister: {  // 注册的表单
                accountRegister:'',
                passwordRegister: '',
                rePassword: '',
                company:'',
                test: '',
                addr:'',
                tags:'',
                name:'',
                phone: '',
            },
            registerForm: {
                registerAccount:'',
                registerPass: '',
                company:'',
            },
            ruleFormMessage: { // 短信的表单
                phone: '',
                code: '',
            },
            rules: {  // 登录的判断
                accountLogin: [
                    { validator: checkLoginAccount, trigger: 'blur' }
                ],
                passLogin: [
                    { validator: validateLoginPass, trigger: 'blur' }
                ]
            },
            registerRules: {
                accountRegister: [
                    { validator: checkAccount, trigger: 'blur' }
                ],
                passwordRegister: [
                    { validator: validatePass, trigger: 'blur' },
                ],
                rePassword: [
                    { validator: validateRePass, trigger: 'blur' }
                ],
                company: [
                    { validator: validateCompany, trigger: 'blur' }
                ],
                test: [
                    { validator: validateTest, trigger: 'blur' }
                ],
                addr: [
                    { validator: validateAddr, trigger: 'blur' }
                ],
                name: [
                    { validator: validateName, trigger: 'blur' }
                ],
                phone: [
                    { validator: checkNum, trigger: 'blur' }
                ],
            },
            registerRulesS: {
                registerAccount: [
                    { validator: validateRegisterAccount, trigger: 'blur' }
                ],
                registerPass: [
                    { validator: validateRegisterPass, trigger: 'blur' }
                ],
                // age: [
                //     { validator: checkAge, trigger: 'blur' }
                // ]
            },
            messageRules: {
                phone: [
                    { validator: checkNum, trigger: 'blur' }
                ],
                code: [
                    { validator: checkCode, trigger: 'blur' }
                ]
            },
            focusArrayLogin:[false,false],
            focusArrayRegister:[false,false,false,false,false,false,false,false],
            focusArrayCode: [false,false],
        };
    },
    methods: {
        // 登录输入框聚焦
        focusHandle(number){
            this.$set(this.focusArrayLogin,number,true)
        },
        // 注册输入框聚焦
        registerFocusHandle(number){
            this.$set(this.focusArrayRegister,number,true)
        },
        codeFocusHandle(number){
            this.$set(this.focusArrayCode,number,true)
        },
        // 跳转注册界面
        toRegister(){
            // this.loginOrRegister = 'register'
            this.wxLogin = 'zc'
            // this.$nextTick(()=>{
                console.log('清空了登录页面',this.$refs['loginRef']);
                this.$refs.loginRef.resetFields();
            // })
        },
        // 跳转登录界面
        toLogin(){
            this.wxLogin = 'account'
            // this.loginOrRegister = 'login'
            // this.$nextTick(()=>{
                console.log('清空了注册页面',this.$refs['registerRef']);
                this.$refs['registerRef'].clearValidate();
            // })
        },
        // 短信，微信，账号切换
        changeWXLogin(format){
            console.log(format);
            this.wxLogin = format
            // this.get_wx_qrcode()
        },
        get_wx_qrcode() {
            //从微信的开发文档不难看出回调域名需要经过encodeURIComponent处理
            var obj = new WxLogin({
                self_redirect: false,//扫码后默认重新打开的回调地址，不是当前页打开
                id: 'wx_login_container',
                appid: 'wxd6125d826622af59',
                scope: 'snsapi_login',
                redirect_uri: encodeURIComponent(
                'http://www.pongo.net.cn/'//配置自己申请的回调地址
                ),
                state: Math.ceil(Math.random() * 1000),
                style: 'black',
                href:'',
            })
        },
        // 点击获取验证码
        getCode(){
            if(this.countdown > 0 || this.isSending) {
                return
            }
            this.isSending = true;
            this.startCountdown();

            let phoneObj = {
                phone: this.ruleFormMessage.phone
            }
            getVerifyCode(phoneObj).then((res)=>{
                if(res.code === 200){
                    this.$message.success('验证码已发送，注意查收');
                    this.isSending = false;
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        // 倒计时计数
        startCountdown(){
            this.countdown = 60;
            const timer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    clearInterval(timer);
                }
            }, 1000);
        },
        // 测试带参数跳转
        testCode(){
            // console.log('点了我了');
            let obj = {
                code: '001NLB100T7W7T1zxn200KIvQK3NLB1P',
                state: false
            }
            this.$router.push({
                path: '/updateFirst',
                query: obj
            })
        },
        // 忘记密码修改
        changePassword(){
            this.$router.push({
                path: '/changePwd'
            })
        },
        changeActiveState(){
            // this.$refs.menu.activeIndex = '';
            this.navIndex = '/index';
        },
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
            // console.log('navIndex', this.navIndex);
            this.navIndex = key
        },
        closeTwoDrawer(boolean){
            this.showDrawer(boolean)
            this.showDrawer2(boolean)
        },
        isShowDrawer2(){
            setTimeout(() => {
                if(this.selectNumber){
                    this.isDrawer3 = true
                }else{
                    this.isDrawer3 = false
                }
            }, 0);
        },
        isShowDrawer3(){
            setTimeout(() => {
                if(this.selectService){
                    this.isDrawer2 = true
                }else{
                    this.isDrawer2 = false
                }
            }, 0)
        },
        showDrawer(boolean){
            this.isDrawer2 = boolean
        },
        showDrawer2(boolean){
            this.isDrawer3 = boolean
        },
        changeIsDrawer2(boolean){
            this.isDrawer2 = boolean
            if(boolean){
                this.selectService = true
            }else{
                this.selectService = false
            }
        },
        changeIsDrawer3(boolean){
            this.isDrawer3 = boolean
            if(boolean){
                this.selectNumber = true
            }else{
                this.selectNumber = false
            }
        },
        showLogout() {
            this.isShowLogout = true;
        },
        hiddenLogout() {
            this.isShowLogout = false;
        },
        goUser() {
            this.$router.push("/user");
        },
        // 跳转到PONGO
        goPongo(url){
            this.$router.push(url);
            this.navIndex = '/pongo'
        },
        userLogout() {
            this.state = false;
            let token = window.localStorage.getItem("refreshToken");
            // let userName = window.localStorage.getItem("userName");
            userExit(token).then(res => {
                if(res.code === 200) {
                    this.$message.success('已退出登录');
                    this.$router.push("/index");
                    window.localStorage.removeItem("userName");
                    window.localStorage.removeItem("userToken");
                    window.localStorage.removeItem("refreshToken");
                }else if(res.code === 300){
                    this.$message.error('登录已过期，请重新登录');
                    this.$router.push("/index");
                    window.localStorage.removeItem("userName");
                    window.localStorage.removeItem("userToken");
                    window.localStorage.removeItem("refreshToken");
                } else{
                    this.$message.error(res.message);
                    this.$router.push("/index");
                }
            });
            this.navIndex = '/index'
        },
        userToRegister() {
            let formData = {
                account: this.ruleFormRegister.accountRegister,
                password: md5(this.ruleFormRegister.passwordRegister),
                phone: this.ruleFormRegister.phone,
                company: this.ruleFormRegister.company,
                enterpriseAddress: this.ruleFormRegister.addr,
                contactName: this.ruleFormRegister.name,
                businessType: this.ruleFormRegister.tags
            }
            // console.log(formData);
            userRegister(formData).then((res) => {
                if(res.code === '0'){
                    this.$message.success('注册成功，已为您跳转登录界面');
                    this.loginOrRegister = 'login';
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        // 更换用户头像和昵称
        changeUserInformation(){
            let obj = {
                token: window.localStorage.getItem('userToken'),
                // id: window.localStorage.getItem('userId')
            }
            // console.log(obj);
            getUserInfo(obj).then(res=>{
                if (res.code === 200){
                    this.userInformation.avatar = res.data.avatar
                    this.userInformation.account = res.data.nickname
                    this.state = true
                }
                else if(res.code === 301) {
                    this.$message.error(res.message)
                    this.state = false
                }else{
                    this.state = false
                    // this.$message.error(res.message)
                }
            })
        },
        // 账号密码登录
        userToLogin(){
            let formData = {
                account: this.ruleForm.accountLogin,
                password: md5(this.ruleForm.passLogin),
            }
            // 表单验证
            // this.$refs.loginRef.validate((valid) => {
            //     if (valid) {
                    userLogin(formData).then(res=>{
                        if(res.code==200){
                            if(res.data.status === 1){
                                this.$message.success('登录成功');
                                window.localStorage.setItem('userToken',res.data.accessToken);
                                window.localStorage.setItem('refreshToken',res.data.refreshToken);
                                // window.localStorage.setItem('userId',res.data.userId);
                                window.localStorage.setItem('userName',formData.account);
                                this.userInformation.account = formData.account
                                this.$store.commit('updateUserState')
                                this.dialogFormVisible = false
                                this.state = true;
                                // 更换主页信息
                                this.changeUserInformation();
                                // this.$router.push('/')
                            }else if(res.data.status === 2){
                                this.$message.error('请先完善个人信息');
                                window.localStorage.setItem('userToken',res.data.accessToken);
                                this.$router.push({path: '/updateFirst'})
                                return
                            }else if(res.data.status === 0){
                                this.$message.error('该账号已被禁用，请联系管理员');
                                return
                            }
                        }else if(res.code==301){
                            this.$message.error("账号或密码错误");
                        }else{
                            this.$message.error(res.message);
                        }
                    })
                // }else {
                //     console.log('chucuole ');
                //     this.$message.error('请输入正确的账号密码');
                //     return false;
                // }
            // })
        },
        // 短信登录
        MessageToLogin(){
            let formData = {
                phone: this.ruleFormMessage.phone,
                code: this.ruleFormMessage.code,
            }
            // 表单验证
            this.$refs['ruleFormMessage'].validate((valid) => {
                if(valid){
                    verifyCodeLogin(formData).then(res=>{
                        if(res.code==200){
                            if(res.data.status === 2){
                                this.$message.info('首次登录请先完善个人信息');
                                window.localStorage.setItem('userToken',res.data.accessToken);
                                window.localStorage.setItem('refreshToken',res.data.refreshToken);
                                this.userInformation = res.data
                                this.changeUserInformation()
                                this.$router.push({path: '/updateFirst'})
                                return
                            }else if(res.data.status === 0){
                                this.$message.error('该账号已被禁用，请联系管理员');
                                return
                            }else if(res.data.status === 1){
                                this.$message.success('登录成功');
                                window.localStorage.setItem('userToken',res.data.accessToken);
                                window.localStorage.setItem('refreshToken',res.data.refreshToken);
                                // window.localStorage.setItem('userName','PONGO' + this.ruleFormMessage.phone);
                                this.userInformation = res.data
                                // this.$store.commit('updateUserState')
                                this.dialogFormVisible = false
                                this.state = true;
                                this.changeUserInformation();
                            }
                            // this.$router.push('/')
                        }else {
                            this.$message.error('验证码错误，请重试');
                            this.isSending = false;
                        }
                    })
                }else {
                    this.$message.error('请输入正确的手机号和验证码');
                    return false;
                }
            })
            
        },
        // backLogin(){
        //     this.loginOrRegister = 'login'
        //     this.$nextTick(()=>{
        //         this.$refs['registerRef'].clearValidate();;
        //     })
        // },
        // goRegister(){
        //     this.loginOrRegister = 'register'
        //     // this.$nextTick(()=>{
        //         console.log(this.$refs['loginRef']);
        //         // this.$refs['loginRef'].clearValidate();;
        //     // })
        // },
        closeDialog() {
            // setTimeout(() => {
            //     this.$nextTick(()=>{
                    // if(this.loginOrRegister=='login'){
                    //     console.log('清空了登录', this.$refs.loginRef);
                        // this.$refs.loginRef.resetFields();;
                    // }else if(this.loginOrRegister=='register'){
                    //     console.log('清空了注册');
                    //     // this.$refs['registerRef'].resetFields();;
                    // }
            //     })
            // }, 500);
            this.wxLogin = 'account'
            this.focusArrayLogin = [false,false]
            this.focusArrayRegister = [false,false,false,false,false,false,false,false]
        },
        navTwoClickHandle(){
            // console.log('点了我了');
            this.navIndex = '/digital_twin'
        }
    },
    watch:{
        $route(to,from){
            this.navIndex = to.path
        }
    },
    // beforeRouteEnter(to, from, next){
    //     console.log(to);
    //     console.log(from);
    //     debugger
    // },
    mounted() {
        this.changeUserInformation()
        // if(this.$route.path)
        // this.navArray
        // 确定导航栏样式
        // if(this.navArray.includes(this.$route.path)){
        //     console.log('又下划线应该');
        this.navIndex = this.$route.path
        // }else{
        //     console.log('应该没有下划线');
        //     this.navIndex = ''
        // }
        // this.state = window.localStorage.getItem('userToken') ? true : false;
        // this.$bus.$on('openLogin',(data) => {
        //     console.log('mounted',data);
        //     this.state = false
        // })
        this.$bus.$on('changeUserInfo',(data) => {
            console.log('修改了头像了:',data);
            // this.userInformation.avatar = data.avatar
            // this.userInformation.account = data.account
            this.changeUserInformation()
        })
        this.$bus.$on('openDialog', (data) => {
            console.log('打开弹窗了',data);
            this.dialogFormVisible = true
        })
        // var obj = new this.wxLogin({
        //     id: 'weixin',
        //     appid: 'wxd6125d826622af59',
        //     scope: 'snsapi_login',
        //     redirect_uri: 'http://localhost:8080',
        // })
    },
    // head:{
    //     script: [
    //         {src: 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'}
    //     ]
    // },
    components:{
        wxlogin
    },
    beforeMount() {
        console.log('before');
    }

};
</script>
<style lang="less" scoped>
a{
    text-decoration: none;
}
.header_nav{
    background-color: #000;
    background-size: cover;
    width: 100%;
    position: fixed;
    z-index: 1000;
    min-width: 1800px;
    @media screen and (max-width: 1600px){
        min-width: 1200px;
    }
    .header_container{
        width: 80%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // position: relative;
        // background-color: rgb(230, 188, 188);
        // padding: 0 5%;
        .avatar{
            // background-color: rgb(0, 154, 79);
            // width: 20%;
            // left: 10%;
        }
        .nav_list{
            // background-color: orange;
            display: flex;
            // justify-content: center;
            // align-items: center;
            // width: 100%;
            // left: 37rem;
        }
        .item_inner{
            // background-color: #54ceec;
            // position: absolute;
            // width: 50%;
            // left: 25%;
            height: 52px;
            // padding-right: 3rem;
        }
        .item_inner:hover{
            border-bottom: 2px #54ceec solid;
        }
        .item_inner_active{
            border-bottom: 2px #54ceec solid;
        }
        .user_avatar{
            height: 52px;
            cursor: pointer;
            position: relative;
            // left: 2%;
            // left: 40rem;
            display: flex;
            align-items: center;
            img {
                margin-right: 5px;
            }
        }
        .logout{
            width: 230px;
            height: 156px;
            position: absolute;
            top: 3.25rem;
            right: 28px;
            background-color: #000000;
            border-radius: 0 0 10px 10px;
            color: #fff;
            font-size: 12px;
            z-index: 1000;
            .el-button {
                border-radius: 20px;
                height: 20px;
                line-height: 0px;
                font-size: 12px;
            }
            .logout_avatar{
                padding: 1rem 0 0 1rem;
                display: flex;
                align-items: center;
                .user_name{
                    margin-left: 1.5rem;
                }
            }
            .logout_line{
                display: flex;
                justify-content: center;
                margin: 12px;
            }
            .user_center{
                padding-left: 1rem;
                margin-top: 1.5rem;
            }
        }
        .avatar_container{
            display: flex;
            align-items: center;
            // height: 52px;
        }
    }
}
.drawer{
    position: fixed;
    z-index: 1000;
    width: 100%;
    .drawer_container{
        background-color: #E0E5EE;
        // opacity: 0.8;
        height: 16rem;
        width: 100%;
        position: absolute;
        top: 3.25rem;
        z-index: 1000;
        display: flex;
        justify-content: space-evenly;
        .container{
            .drawer_title{
                font-size: 1.1rem;
                font-weight: 600;
                letter-spacing: 2px;
                padding: 1.5rem 0rem 1.5rem 0rem;
                .inner_tittle{
                    color: #000;
                }
                .inner_tittle:hover{
                    color: #54ceec
                }
            }
            .drawer_inner{
                .drawer_inner_span{
                    display: inline-block;
                    color: #727272;
                    letter-spacing: 0.1rem;
                    margin-bottom: 1.2rem;
                }
                .drawer_inner_span:hover{
                    color: #54ceec;
                }
            }
        }
    }
    .drawer_container_bgc{
        background-color: #E0E5EE;
        display: flex;
        justify-content: center;
        padding: 0 5%;
        .pongo_intro{
            width: 35%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            /* align-items: center; */
            // padding-left: 6rem;
            font-size: 0.8rem;
            // background-color: #54ceec;
            color: #9e9e9e;
            line-height: 2;
        }
        .pongo_nav_list{
            width: 40%;
            display: flex;
            align-items: center;
            .list_container{
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                height: 60%;
                .item{
                    width: 50%;
                    display: flex;
                    // justify-content: center;
                    align-items: center;
                    // height: 30%;
                    font-size: 1.2rem;
                    cursor: pointer;
                }
                .item:hover{
                    color: #54ceec;
                }
            }
        }
        .pongo_logo{
            width: 20%;
            display: flex;
            justify-content: right;
            align-items: center;
        }
    }
}
.drawer2{
    .drawer_container{
        height: 10rem;
    }
}
.dialog-footer{
    padding: 0 0 14% 0;
}
.el-button {
    background-color: #54ceec;
    border: 0px;
    color: #ffffff;
    font-size: 16px;
}

.el-button:hover {
    background-color: #fff;
    border: 0px;
    color: #54ceec;
    font-size: 16px;
}

::v-deep .el-menu {
    background-color: black !important;
}
.el-menu-item, .el-submenu {
    // width: 150px;
    font-family: 'HarmonyOS Sans Sc';
    font-size: 16px ;
    color: #ffffff ;
    text-align: center;
    background-color: #000 !important;
}
.el-menu-item{
    padding: 0 2rem;
}
.el-menu--horizontal>.el-menu-item {
    font-size: 16px ;
    color: #ffffff ;
    height: 52px;
    line-height: 52px;
}
::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title {
    color: #ffffff ;
    font-size: 16px;
    height: 52px;
    line-height: 52px;
}

::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    background-color: #000 ;
    color: #54ceec;
}

// ::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title:active {
//     color: #54ceec;
// }

::v-deep .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: none;
    color: #54ceec;
}

.el-menu--horizontal>.el-menu-item:focus,.el-menu--horizontal>.el-menu-item:hover {
    color: #54ceec !important;
}

::v-deep .el-submenu__title:active {
    color: #54ceec;
}
::v-deep .el-submenu .el-submenu__title a:hover {
    color: #54ceec;
}
::v-deep .el-menu--popup-bottom-start {
    background-color: #000 !important;
}

::v-deep .el-menu--horizontal .el-menu .el-menu-item{
    background-color: #000;
}

::v-deep .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
    color: #54ceec !important;
    text-align: center;
    border-bottom: 2px solid #54ceec;
}
.dialog_container{
    // width: 800px;
    // height: 500px;
    margin: 0 auto;
    // background-color: #54ceec;
    display: flex;
    .dialog_left{
        width: 45%;
        // background-color: #54ceec;
        background-image: url("../../assets/image/2.1.png");
        // background-size: 970px 585px;
        background-repeat: no-repeat;
        display: flex;
        background-position: center;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 10px 0px 0px 10px;
        .name{
            font-weight: bolder;
            margin-top: 20px;
        }
    }
    .dialog_right{
        width: 55%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #E3E8EF;
        border-radius: 0 10px 10px 0;
        padding: 3rem 0;
        .right_container{
            width: 100%;
            border-left: 1px dashed #ababab;
            .login_format{
                width: 100%;
                // background-color: chartreuse;
                display: flex;
                flex-direction: column;
                // justify-content: center;
                align-items: center;
                .duanxin{
                    .codeBtn{
                        background-color: #54ceec;
                        border-radius: 20px;
                        padding: 8px 10px 10px 10px;
                    }
                    .codeBtn:hover{
                        color: #E3E8EF;
                    }
                    .button{
                        ::v-deep .el-button{
                            width: 100%;
                            border-radius: 20px;
                            margin-top: 1rem;
                        }
                    }
                }
                .impowerBox .title{
                    display: none;
                }
            }
            .register_format{
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            .title{
                font-size: 1.7rem;
                letter-spacing: 5px;
                padding: 1rem 0 2rem;
            }
            .forget{
                // background-color: #54ceec;
                display: flex;
                justify-content: flex-end;
                span{
                    cursor: pointer;
                }
                span:hover{
                    color: #54ceec;
                }
                ::v-deep .el-form-item{
                    margin-bottom: 1rem !important;
                }
            }
            .other{
                text-align: center;
                color: #a3a3a3;
                font-size: 0.8rem;
                position: relative;/*定位横线（当横线的父元素）*/
                display: block;
                // padding-top: 2rem;
            }
            .other::before,
            .other::after{
                content: '';
                position: absolute;
                top: 52%;
                background: #a3a3a3;
                /*宽和高做出来的背景横线*/
                width: 100%;
                height: 1px;
            }
            .other::before {
                left: 100%;/*调整背景横线的左右距离*/
            }
            .other::after {
                right: 100%;/*调整背景横线的左右距离*/
            }
            .bottom{
                padding-top: 2rem;
                display: flex;
                .wx{
                    display: flex;
                    margin-right: 3rem;
                    align-items: center;
                    cursor: pointer;
                    span{
                        margin-left: 0.5rem;
                    }
                }
                .dx{
                    display: flex;
                    cursor: pointer;
                    align-items: center;
                    span{
                        margin-left: 0.5rem;
                    }
                }
            }
            .button{
                display: flex;
                justify-content: center;
                margin-bottom: 1rem;
                ::v-deep .el-button{
                    width: 100%;
                    border-radius: 20px;
                }
                .register{
                    background-color: #f0f0f0;
                    color: #8c8c8c;
                }
                .register:hover{
                    background-color: #fff;
                }
                ::v-deep .el-form-item{
                    margin-bottom: 1rem !important;
                }
            }
            ::v-deep .el-input__inner{
                // background-color: #f9b6f2;
                width: 20rem;
            }
        }
    }
}
.login_avatar{
    .logo_container{
        background-image: url("../../assets/image/10.png");
        padding: 30% 38% 20% 39%;
        background-size: cover;
    }
}
.login_title{
    margin: 7%;
    text-align: center;
    font-size: 1.8rem;
    font-weight: 500;
    letter-spacing: 3px;
}
::v-deep .el-dialog{
    width: 50%;
    min-width: 8%;
    // max-width: 600px;
    border-radius: 8px;
    margin-top: 13vh !important;
    // background-color: rebeccapurple;
    // background-image: url("../../assets/image/2.用户登录底图.png");
}
::v-deep .el-dialog__header, ::v-deep .el-dialog--center .el-dialog__body, ::v-deep .el-dialog__footer{
    padding: 0;
}
::v-deep .el-form-item__content{
    margin: 0 50px !important;
}
::v-deep .el-form-item{
    margin-bottom: 22px;
}
::v-deep .el-input__inner{
    border-radius: 20px;
}
::v-deep .el-input__prefix{
    top: 3px;
    left: 10px;
}
::v-deep .el-input--prefix .el-input__inner{
    padding-left: 48px;
}
.login_btn1{
    width: 25%;
    border-radius: 20px;
    margin-right: 6%;
}
.login_btn2{
    width: 25%;
    border-radius: 20px;
}
</style>
